import Vuex from 'vuex';
import Vue from 'vue'
import * as web from '@/WebUtil/storage';
import * as i18n from '@/lang/lang';
import Swal from "sweetalert2";
Vue.use(Vuex)

let store = new Vuex.Store({
    state: {
        pageAni: web.getLocal(web.StorageKey.pageAni) || "roll",
        mainColor: web.getLocal(web.StorageKey.mainColor) || "green",
        isDark: web.getLocal(web.StorageKey.isDark) || false,
        langType: web.getLocal(web.StorageKey.langType) || "tw"
    },
    mutations: {
        setAni(state, ani) {
            if (web.setLocal(web.StorageKey.pageAni, ani)) {
                state.pageAni = ani;
            } else {
                console.error("Error:Can't Store pageAni");
            }
        },
        setMainColor(state, color) {
            if (web.setLocal(web.StorageKey.mainColor, color)) {
                state.mainColor = color;
            } else {
                console.error("Error:Can't Store mainColor");
            }
        },
        setIsDark(state, bool) {
            if (web.setLocal(web.StorageKey.isDark, bool)) {
                state.isDark = bool;
            } else {
                console.error("Error:Can't Store mainColor");
            }
        },
        setLangType(state, data) {
            if (data == "en") {
                Swal.fire({
                    type: 'warning',
                    title: 'Oops...',
                    text: 'Under construction...',
                })
            } else {
                if (web.setLocal(web.StorageKey.langType, data)) {
                    state.langType = data;
                    i18n.setup(data);
                } else {
                    console.error("Error:Can't Store LangType");
                }
            }
        }
    },
    actions: {
        changeAni({
            context,
            state
        }, ani) {
            context.commit("setAni", ani)
        },
        changeMainColor({
            context,
            state
        }, color) {
            context.commit("setMainColor", color)
        },
        changeDarkTheme({
            context,
            state
        }, bool) {
            context.commit("setIsDark", bool)
        }
    }
})
export default store


// WEBPACK FOOTER //
// ./src/store/index.js